// extracted by mini-css-extract-plugin
export var aircallIframe = "_k8-3";
export var fabContainer = "_k8-5";
export var fabRinging = "_k8-6";
export var loadingOverlay = "_k8-4";
export var pulse = "_k8-7";
export var widgetContent = "_k8-2";
export var widgetPanel = "_k8-0";
export var widgetPanelExpanded = "_k8-1";